/** Anchor text of the in-body links to /ksiegowosc-ai (INTERNAL-LINKS.md, table B): one per page, all different. */
export const AI_ACCOUNTING_ANCHORS = {
  home: 'Księgowość AI dla JDG: co robi AI, a co liczy kod',
  jdg: 'księgowość AI dla JDG',
  ksef: 'Księgowość AI dla JDG',
} as const;
